"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateYmd = formatDateYmd;
exports.formatYxq = formatYxq;
exports.isCouponConfigExpired = isCouponConfigExpired;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
/**
 * 券有效期展示（对齐 CRM formatYxq）
 * expiryType: '0' 固定 | '1' 领后固定天数 | '2' 领后至指定日 | '3' 领取当月有效
 */
function formatDateYmd(date) {
  if (!date) return '';
  var d = new Date(date);
  if (isNaN(d.getTime())) return '';
  var y = d.getFullYear();
  var m = String(d.getMonth() + 1).padStart(2, '0');
  var day = String(d.getDate()).padStart(2, '0');
  return "".concat(y, "-").concat(m, "-").concat(day);
}
function formatYxq(res) {
  if (!res) return '';
  var yxq = '';
  var weekDesc = '';
  if (res.isAllweek !== undefined && res.isAllweek !== null) {
    weekDesc = Number(res.isAllweek) === 1 ? '（适用全部星期）' : '（部分星期有效）';
  }
  var expiryType = res.expiryType != null ? String(res.expiryType) : '';
  if (expiryType === '3') {
    yxq = '领取当月有效';
  } else if (expiryType === '1') {
    var isHour = Number(res.afterType) === 1;
    var unit = isHour ? '小时' : '天';
    var after = isHour ? res.afterHours || 0 : res.afterDays || 0;
    var days = res.expiryDays || 0;
    yxq = "\u9886\u53D6\u540E\u7B2C".concat(after).concat(unit, "\u751F\u6548\uFF0C\u6709\u6548").concat(days, "\u5929").concat(weekDesc);
  } else if (expiryType === '2') {
    var _isHour = Number(res.afterType) === 1;
    var _unit = _isHour ? '小时' : '天';
    var _after = _isHour ? res.afterHours || 0 : res.afterDays || 0;
    yxq = "\u9886\u53D6\u540E\u7B2C".concat(_after).concat(_unit, "\u751F\u6548\uFF0C\u622A\u6B62\u81F3").concat(formatDateYmd(res.expiryEnd));
  } else if (expiryType === '0' || expiryType === '') {
    var start = formatDateYmd(res.expiryStart);
    var end = formatDateYmd(res.expiryEnd);
    if (!start && !end) return '';
    yxq = "".concat(start || '-', "~").concat(end || '-');
  } else {
    // 其它未知类型：尽量拼日期
    var _start = formatDateYmd(res.expiryStart);
    var _end = formatDateYmd(res.expiryEnd);
    if (_start || _end) {
      yxq = "".concat(_start || '-', "~").concat(_end || '-');
    }
  }
  return yxq;
}

/** 是否按日历判断过期（type 0/2）；1/3 领取后才确定，配置态不标过期 */
function isCouponConfigExpired(row) {
  if (!row) return false;
  var t = row.expiryType != null ? String(row.expiryType) : '';
  if (t === '1' || t === '3') return false;
  var now = new Date();
  var start = row.expiryStart ? new Date(row.expiryStart) : null;
  var end = row.expiryEnd ? new Date(row.expiryEnd) : null;
  if (end && now > end) return true;
  if (t === '0' && start && now < start) return true;
  return false;
}